import {
  type FeatureGateEnvironment,
  PerimeterType,
} from '@atlaskit/feature-gate-js-client';
import FeatureGateClient from '@atlaskit/feature-gate-js-client/client';

export let localPlatformFeatureFlagClientPromise: Promise<void> | undefined = undefined;
export let localPlatformFeatureFlagClient: FeatureGateClient | undefined = undefined;

export const loadLocalPlatformFeatureFlags = (sessionData?: {
  accountId: string;
  tenantId: string;
}) => {
  if (localPlatformFeatureFlagClientPromise) {
    return localPlatformFeatureFlagClientPromise;
  }

  localPlatformFeatureFlagClientPromise = (async () => {
    if (!sessionData) {
      return;
    }

    if (
      process.env.VITE_LOCAL_DEV_PLATFORM_FEATURE_FLAGS_ENV &&
      process.env.VITE_LOCAL_DEV_PLATFORM_FEATURE_FLAGS_API_KEY &&
      process.env.VITE_LOCAL_DEV_PLATFORM_FEATURE_FLAGS_TARGET_APP
    ) {
      const client = new FeatureGateClient();

      await client.initialize(
        {
          environment: process.env
            .VITE_LOCAL_DEV_PLATFORM_FEATURE_FLAGS_ENV as FeatureGateEnvironment,
          apiKey: process.env.VITE_LOCAL_DEV_PLATFORM_FEATURE_FLAGS_API_KEY,
          targetApp: process.env.VITE_LOCAL_DEV_PLATFORM_FEATURE_FLAGS_TARGET_APP,
          useGatewayURL: true,
          fetchTimeoutMs: 5000,
          perimeter: PerimeterType.COMMERCIAL,
        },
        {
          atlassianAccountId: sessionData.accountId,
          tenantId: sessionData.tenantId,
        }
      );
      localPlatformFeatureFlagClient = client;
    }
  })();

  return localPlatformFeatureFlagClientPromise;
};
